import Flex from 'components/common/Flex';
// import VerifiedBadge from 'components/common/VerifiedBadge';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
// import { Image } from 'react-bootstrap';

const Experience = ({
  index,
  experience,
  isLast,
  experiences,
  setExperiences
}) => {
  const {
    // logo,
    title,
    company,
    startDate,
    endDate,
    currentlyWork,
    location
    // verified
  } = experience;

  // console.log(experience);

  function getExperience(currentlyWork, startDate, endDate) {
    if (currentlyWork) {
      return 'Present';
    } else {
      const start = new Date(startDate);
      const end = new Date(endDate);

      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      const years = Math.floor(diffDays / 365);
      const months = Math.floor((diffDays % 365) / 30);

      let output = '';
      if (years > 0) {
        output += years + ' y ';
      }
      if (months > 0) {
        output += months + ' m';
      }

      return output.trim();
    }
  }

  const handleRemoveWorkExperience = index => {
    const updatedWorkExperience = [...experiences];
    updatedWorkExperience.splice(index, 1);
    setExperiences(updatedWorkExperience);
  };

  return (
    <Flex>
      {/*<Link to="#!"> <Image fluid src={logo} width={56} /> </Link>*/}
      <div className="flex-1 position-relative ps-3">
        <h6 className="fs-9 mb-0">
          {title}
          {/* {verified && <VerifiedBadge />} */}
        </h6>
        <p className="mb-1">
          {/* <Link to="#!">{company}</Link> */}
          {company}
        </p>
        <p className="text-1000 mb-0">
          {`${moment(startDate).format('MM-DD-YYYY')} - ${moment(
            endDate
          ).format('MM-DD-YYYY')} • ${getExperience(
            currentlyWork,
            startDate,
            endDate
          )}`}
        </p>
        <p className="text-1000 mb-0">{location}</p>
        <Button
          size="sm"
          variant={'danger'}
          className="mt-2"
          onClick={() => handleRemoveWorkExperience(index)}
        >
          Remove
        </Button>
        {!isLast && <div className="border-dashed border-bottom my-3" />}
      </div>
    </Flex>
  );
};
Experience.propTypes = {
  experience: PropTypes.any,
  index: PropTypes.any,
  isLast: PropTypes.bool,
  experiences: PropTypes.any,
  setExperiences: PropTypes.func.isRequired
};
export default Experience;
